module.exports = __webpack_public_path__ + "img/care_guide_2.0c13d3b3.png";